import { AnalyticsECommerceUniversalShoppingBasketProductType } from '#src/components/Common/analytics/AnalyticsECommerce/AnalyticsECommerce.types';
import { UniversalShoppingBasketProductType } from '#src/generated/graphql';

export const eCommerceProductTypeMapper: Record<
  AnalyticsECommerceUniversalShoppingBasketProductType,
  string
> = {
  ACCOMMODATION: 'HOTEL',
  AIRPORT_FAST_TRACK: 'FASTTRACK',
  BAGGAGE: 'BAG',
  ITINERARY_PRICE_FREEZE: 'PRICE_FREEZE_FLIGHT',
  MEMBERSHIP_RENEWAL: 'SUBSCRIPTION_RENEWAL',
  MEMBERSHIP_SUBSCRIPTION: 'SUBSCRIPTION',
  SEAT: 'SEAT',
};

export const mapECommerceProductName = (
  productName: UniversalShoppingBasketProductType
): string => {
  if (productName in eCommerceProductTypeMapper) {
    return eCommerceProductTypeMapper[productName];
  }

  return productName;
};
